import { Col, Row, Space, Button, Radio, DatePicker } from "antd";
import { Form, Formik } from "formik";

import { Input, Select } from "components/form";
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";
import {
  initialValues as INITIAL_VALUES
} from "../schemas/employeeCreateSchema";
import styles from "../styles/EmployeeFilter.module.css";
import { FormSelect } from "components/form/FormProvide";
import { getBranch } from "../services/employeeApi";
import { useCallback, useEffect, useMemo } from "react";
import { setIsLoading } from "../slices/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentBranch } from "features/company/slices/companySlice";
import { setSocialSecurityBranchOption } from "../slices/optionsSlice";
import { getSocialSecurityBranch } from "features/masterData/services/optionsApi";
import { useLocation } from "react-router-dom";
import DateRangePicker from "components/form/DatePicker/RangePicker";

const EmployeeFilter = ({
  // initialValues = {},
  // shiftOptions = [],
  // titleNameOptions = [],
  // employeeTypeOptions = [],
  genderOptions = [],
  positionOption = [],
  // modifiedPositionOptions = [],
  organizationUnderOptions = [],
  employeeTypeOptions = [],
  employmentTypeOptions = [],
  employeeStatusTypeOptions = [],
  // workInLocationOptions = [],
  // durationOptions = [],
  // supervisorOptions = [],
  shiftDropDown = [],
  onSubmit = () => { },
  onClear = () => { }
  // onCancel = () => { },
}) => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const socialSecurityBranchOptions = useSelector(
    (state) => state?.options?.socialSecurityBranchOption
  );
  const currentCompany = useSelector((state) => state.company.currentCompany);

  // const [loading, setLoading] = useState(false);
  // const [imageUrl, setImageUrl] = useState(null);
  // const [optionType, setOptionType] = useState(null);
  // const [ageRange, setAgeRange] = useState([18, 65]);
  // const [startBirthDate, setStartBirthDate] = useState(); // Default age range
  // const [endBirthDate, setEndBirthDate] = useState(); // Default age range

  // const handleAgeRangeChange = (value) => {
  //   setAgeRange(value);
  // };

  // const handleMinAgeChange = (value) => {
  //   setAgeRange([value, ageRange[1]]);
  //   setEndBirthDate([value, ageRange[1]]);
  // };
  const modifiedSocialSecurityBranchOptions = useMemo(() => {
    const modifiedOptions = socialSecurityBranchOptions.map((opt) => ({
      ...opt,
      // label: lang === "en" ? opt.commonTypeNameEn : opt.commonTypeName,
      // value: opt.id,
      label: i18n.language === "en" ? opt.nameEn : opt.name,
      value: opt.id,
    }));
    return modifiedOptions;
  }, [i18n.language, socialSecurityBranchOptions]);

  const location = useLocation()
  console.log("location", location);
  // const handleMaxAgeChange = (value) => {
  //   setAgeRange([ageRange[0], value]);
  //   setStartBirthDate([ageRange[0], value]);
  // };
  const getSocialSecurityBranchOption = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await getSocialSecurityBranch({
        companyId: currentCompany
      });

      dispatch(setSocialSecurityBranchOption(response.data));
    } catch (error) {
      // alert({
      //   type: "error",
      //   resultObject: error,
      //   message: "Get social security branch failed!!!",
      // });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch]);

  useEffect(() => {
    getSocialSecurityBranchOption()
  }, [])


  const filterValueGender = useCallback(
    () => {
      if (location?.state?.item?.series == 'genderId') {
        return { [location?.state?.item?.series]: genderOptions?.find(o => o.label == location?.state?.item?.value)?.value, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      if (location?.state?.item?.series == 'listEmployeeTypeId') {
        return { [location?.state?.item?.series]: location?.state?.item?.value, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      if (location?.state?.item?.series == 'listBranch') {
        return { [location?.state?.item?.series]: location?.state?.item?.value, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      if (location?.state?.item?.series == 'listEmployeeStatus') {
        let size = location?.state?.item?.value
        const startDate = location?.state?.item?.startDate
          ? dayjs(location?.state?.item?.startDate)
          : dayjs().startOf('month')

        const endDate = location?.state?.item?.endDate
          ? dayjs(location?.state?.item?.endDate)
          : dayjs()
        let employmentDateRange = null
        // if (size?.length > 1) {
        //   employmentDateRange = [dayjs(location?.state?.item?.startDate) ?? dayjs().startOf('month'), dayjs()]
        // }
        if (size?.length > 1) {
          employmentDateRange = [startDate, endDate]
        }
        console.log("locationlocation", location, size?.length, employmentDateRange);

        return { [location?.state?.item?.series]: location?.state?.item?.value, employmentDateRange, expireDateRange: [startDate, endDate] }
      }
      if (location?.state?.item?.series == 'listDepartmentId') {
        return { [location?.state?.item?.series]: location?.state?.item?.value || null, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      return { genderId: null, listEmployeeTypeId: null, listEmployeeStatus: null, listBranch: null, listDepartmentId: null }
    },
    [location?.state?.item?.series, location?.state?.item?.startDate, location?.state?.item?.value, genderOptions],
  )
  console.log("filterValueGender", filterValueGender());


  return (
    <Formik
      initialValues={
        {
          ...INITIAL_VALUES,
          ...(filterValueGender() ?? {})
        }
      }
      onSubmit={(values) => {
        onSubmit({
          ...values,
          // ageRange: ageRange,
          // startBirthDate: ageRange[0],
          // endBirthDate: ageRange[1],
        });
      }}
    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        console.log("values", values);

        return (
          <Form>
            <Row gutter={[24, 16]} className={styles.filter} >
              <Col span={8}>
                <Input
                  name="employeeNo"
                  label={t("employment-information.label.empId")}
                  placeholder={t("employment-information.label.empId")}
                  size="large"
                />
              </Col>
              {/* <Col span={8}>
                <Input
                  required={true}
                  name="email"
                  label={
                    t("employee.label.email")
                  }
                  placeholder={
                    t("employee.label.email")

                  }
                  size="large"
                />
              </Col> */}
              <Col span={8}>
                <Input
                  // required={true}
                  name="name"
                  label={t('employee.label.email') + " / " + t('employee.label.employee-name') + " / " + t('employee.label.employee-nickName')}
                  placeholder={
                    t('employee.label.employee-name')

                  }
                  size="large"
                />
              </Col>

              {/* <Col span={8}>
                <Select
                  name="durationOfWorkId"
                  label={t('translation.durationofwork')}
                  placeholder={t('translation.durationofwork')}
                  size="large"
                  options={durationOptions}
                />
              </Col>
              <Col span={8} className="custom-slider" styles={{ paddingTop: "10px" }}>
                <div>
                  Age Range: <InputNumber
                    name="startBirthDate"
                    className="age-input"
                    min={0}
                    max={100}
                    value={ageRange[0]}
                    onChange={handleMinAgeChange}
                  /> - <InputNumber
                    name="endBirthDate"
                    className="age-input"
                    min={0}
                    max={100}
                    value={ageRange[1]}
                    onChange={handleMaxAgeChange}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>

                  <Slider
                    range
                    min={0}
                    max={100}
                    value={ageRange}
                    onChange={handleAgeRangeChange}
                    style={{ flex: 1, margin: '0 10px' }}
                  />
                </div>
              </Col> */}
              <Col span={8}>
                <Select
                  name="listDepartmentId"
                  label={t('employment-information.label.department')}
                  placeholder={t('employment-information.label.department')}
                  size="large"
                  options={organizationUnderOptions}
                  tree={true}
                  multiple={true}
                />
              </Col>
              {/* <Col span={8}>
                <Select
                  name="workLocation"
                  label={t('translation.worklocation')}
                  placeholder={t('translation.worklocation')}
                  size="large"
                  options={workInLocationOptions}
                />
              </Col> */}

              <Col span={8}>
                <Select
                  name="listShiftId"
                  label={t("translation.shift.entity")}
                  placeholder={t("translation.shift.entity")}
                  size="large"
                  mode="multiple"
                  options={shiftDropDown}
                />
              </Col>
              <Col span={8}>
                <Select
                  name="listEmployeeTypeId"
                  options={employeeTypeOptions}
                  label={t('employment-information.label.employee-type')}
                  allowClear
                  size="large"
                  placeholder={t('employment-information.label.employee-type')}
                  mode="multiple"
                />
              </Col>
              <Col span={8}>
                <Select
                  name="listEmploymentType"
                  options={employmentTypeOptions}
                  label={t('employment-information.label.employment-type')}
                  allowClear
                  size="large"
                  placeholder={t('employment-information.label.employment-type')}
                  mode="multiple"
                />
              </Col>
              <Col span={8}>
                <Select
                  name="listEmployeeStatus"
                  options={employeeStatusTypeOptions}
                  label={t('status.entity')}
                  allowClear
                  size="large"
                  placeholder={t('status.entity')}
                  mode="multiple"
                />
              </Col>
              <Col span={8}>
                <Select
                  name="listBranch"
                  options={modifiedSocialSecurityBranchOptions}
                  label={t('status.branch')}
                  allowClear
                  size="large"
                  placeholder={t('status.branch')}
                  mode="multiple"
                />
              </Col>
              <Col span={8}>
                <Select
                  name="listPositionId"
                  label={t('translation.postion')}
                  placeholder={t("translation.postion")}
                  size="large"
                  options={positionOption}
                  multiple={true}
                  tree={true}
                />
              </Col>
              <Col span={8}>
                <Select
                  // required={true}
                  name="genderId"
                  label={t('gender-1')}
                  placeholder={t('gender-1')}
                  size="large"
                  options={genderOptions}
                  sorting={false}
                />
              </Col>
              <Col span={8}>
                <DateRangePicker
                  // required={true}
                  name="employmentDateRange"
                  label={t('employmentDate')}
                  placeholder={t('employmentDate')}
                  size="large"
                  sorting={false}
                />
              </Col>
              <Col span={8}>
                <DateRangePicker
                  // required={true}
                  name="expireDateRange"
                  label={t('expireDate')}
                  placeholder={t('expireDate')}
                  size="large"
                  sorting={false}
                />
              </Col>
            </Row>
            <Row justify="end">
              <Space size={12} className={styles.filterbtn}>
                <Button type="default" onClick={() => {
                  resetForm()
                  setFieldValue('genderId', null)
                  setFieldValue('listEmployeeTypeId', null)
                  setFieldValue('listBranch', null)
                  setFieldValue('listEmployeeStatus', null)
                  setFieldValue('listDepartmentId', null)
                  setFieldValue('expireDateRange', null)
                  setFieldValue('employmentDateRange', null)
                  onClear?.()
                }} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}>
                  {t("common.clear").toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default EmployeeFilter;
